import { createFileRoute, Link } from '@tanstack/react-router';

import { Button } from '~/components/ui/Button.js';
import { Spinner } from '~/components/ui/Spinner.js';
import { ProjectForm } from '~/features/projects/ProjectForm.js';
import { useSectorsList } from '~/features/taxonomies/hooks.js';

export const Route = createFileRoute('/_auth/projects/new')({
  component: ProjectNewPage,
});

function ProjectNewPage() {
  const { data: sectors, isLoading, error } = useSectorsList();

  return (
    <div className="page">
      <header className="page-head">
        <p className="eyebrow">/ Portfólio</p>
        <h1 className="page-title">Novo projeto</h1>
        <p className="page-sub">
          Cadastre um contrato ou projeto em estruturação. Após criado, ele pode ser editado a
          qualquer momento. Para esconder do site sem perder o histórico, desligue "Exibir mapa" e
          "Exibir home".
        </p>
      </header>

      {isLoading && (
        <div className="dt__state">
          <Spinner size="lg" />
        </div>
      )}

      {error && (
        <div className="dt__state">
          <p className="dt__state-title">Não foi possível carregar setores.</p>
          <p className="dt__state-sub">{error.displayMessage}</p>
        </div>
      )}

      {sectors && <ProjectForm sectors={sectors} />}

      <Link to="/projects">
        <Button variant="ghost">← Voltar à lista</Button>
      </Link>
    </div>
  );
}
